export default __webpack_public_path__ + "static/media/construction.fa62068b.gif";